import { render, staticRenderFns } from "./AddOrEditQuestionAnswerInfo.vue?vue&type=template&id=0c45bb98&scoped=true"
import script from "./AddOrEditQuestionAnswerInfo.vue?vue&type=script&lang=js"
export * from "./AddOrEditQuestionAnswerInfo.vue?vue&type=script&lang=js"
import style0 from "./AddOrEditQuestionAnswerInfo.vue?vue&type=style&index=0&id=0c45bb98&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c45bb98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/ap/jenkins/workspace/prod-ykd360-admin-front(医可达旧管理端)/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c45bb98')) {
      api.createRecord('0c45bb98', component.options)
    } else {
      api.reload('0c45bb98', component.options)
    }
    module.hot.accept("./AddOrEditQuestionAnswerInfo.vue?vue&type=template&id=0c45bb98&scoped=true", function () {
      api.rerender('0c45bb98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/questionnaire/question/sub/AddOrEditQuestionAnswerInfo.vue"
export default component.exports